import axios from './customAxiosFiles';

const reportesProvider = {
  exportarFichas: async () => {
    return await axios.get('/reportes/RptFichas', {
      responseType: 'blob'
    });
  },
  exportarPadron: async (eleccion) => {
    return await axios.get(`/reportes/RptPadronElectoral/${eleccion}`, {
      responseType: 'blob'
    });
  }
};

export default reportesProvider;